import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import BaseLayer from "../core/BaseLayer";
import PolygonModels from "./models/";
export default class PolygonLayer extends BaseLayer {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "type", 'PolygonLayer');
    _defineProperty(this, "enableShaderEncodeStyles", ['opacity', 'extrusionBase',
    // shape 为文本时
    'rotation', 'offsets', 'stroke']);
  }
  buildModels() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const shape = _this.getModelType();
      _this.layerModel = new PolygonModels[shape](_this);
      yield _this.initLayerModels();
    })();
  }
  getModelType() {
    var _shapeAttribute$scale;
    const shapeAttribute = this.styleAttributeService.getLayerStyleAttribute('shape');
    const shape = shapeAttribute === null || shapeAttribute === void 0 || (_shapeAttribute$scale = shapeAttribute.scale) === null || _shapeAttribute$scale === void 0 ? void 0 : _shapeAttribute$scale.field;
    if (shape === 'fill' || !shape) {
      return 'fill';
    } else if (shape === 'extrude') {
      return 'extrude';
    } else if (shape === 'extrusion') {
      return 'extrusion';
    } else if (shape === 'water') {
      return 'water';
    } else if (shape === 'ocean') {
      return 'ocean';
    } else if (shape === 'line') {
      return 'line';
    } else {
      return this.getPointModelType();
    }
  }
  getPointModelType() {
    // pointlayer
    //  2D、 3d、 shape、image、text、normal、
    const layerData = this.getEncodedData();
    const {
      shape2d,
      shape3d
    } = this.getLayerConfig();
    const iconMap = this.iconService.getIconMap();
    const item = layerData.find(fe => {
      return fe.hasOwnProperty('shape');
    });
    if (!item) {
      return 'fill';
    } else {
      const shape = item.shape;
      if (shape === 'dot') {
        return 'point_normal';
      }
      if ((shape2d === null || shape2d === void 0 ? void 0 : shape2d.indexOf(shape)) !== -1) {
        return 'point_fill';
      }
      if ((shape3d === null || shape3d === void 0 ? void 0 : shape3d.indexOf(shape)) !== -1) {
        return 'point_extrude';
      }
      if (iconMap.hasOwnProperty(shape)) {
        return 'point_image';
      }
      return 'text';
    }
  }
}